<template>
  <vs-popup :active.sync="showPopup" id="LoadingDialog" style="z-index: 9999999">
    <div class="flex items-center justify-center">
      <img src="@/assets/icons/loading.svg" class="spin" />
      <div class="message">
        <p>처리중입니다...</p>
        <p class="count" v-if="num > 0 && total > 0">({{num}}/{{total}}{{unit ? ` ${unit}` : ''}})</p>
      </div>
    </div>
    <div class="progress" v-if="total > 0">
      <div class="progress-bar" :style="{ width: `${percent}%` }"></div>
      <span class="progress-text">{{ percent }}%</span>
    </div>
    <div class="w-screen h-screen absolute top-0 left-0 z-50" @click.stop></div>
  </vs-popup>
</template>

<script>
export default {
  data() {
    return {
      showPopup: false,
      num: 0,
      total: 0,
      unit: '',
    };
  },
  computed: {
    percent() {
      if (!this.total) return 0;
      return Math.min(100, Math.floor((this.num / this.total) * 100));
    },
  },
  mounted() {
    window.addEventListener("loadingDialog", this.loadingDialog);
  },
  beforeDestroy() {
    window.removeEventListener("loadingDialog", this.loadingDialog);
  },
  methods: {
    loadingDialog(event) {
      const { open, num, total, unit } = event.detail;
      this.showPopup = open;
      this.num = open ? num : 0;
      this.total = open ? total : 0;
      this.unit = open ? unit : "";
    },
  },
};
</script>

<style lang="scss" scoped>
#LoadingDialog::v-deep {
  header {
    display: none;
  }
  .vs-popup {
    position: unset;
    width: auto;
    min-width: 252px;
    max-width: 90vw;
  }
  // 내용이 잘려 스크롤이 생기지 않도록 한다
  .vs-popup--content {
    overflow: visible;
    max-height: none;
    padding: 20px;
    margin: 0;
  }
}
.message {
  padding: 0 16px;
  white-space: nowrap;
}
p {
  font-weight: 400;
  font-size: 18px;
  line-height: 22px;
  color: #757575;

  &.count {
    margin-top: 4px;
    font-size: 16px;
  }
}
.progress {
  position: relative;
  margin: 14px 4px 0;
  height: 8px;
  background-color: #eeeeee;
  border-radius: 4px;
  overflow: visible;

  .progress-bar {
    height: 8px;
    background-color: #7e72f2;
    border-radius: 4px;
    transition: width 0.2s ease;
  }
  .progress-text {
    display: block;
    margin-top: 6px;
    text-align: center;
    font-size: 12px;
    color: #757575;
  }
}
.spin {
  animation: lds-spinner 1s infinite steps(12);
}
@keyframes lds-spinner {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
